export const Marquee = ({ text }) => {
  const phrase = text || "SELECTED WORKS // ESSAYS // PUBLICATIONS // NOCTURNAL INSIGHTS // ";
  const strip = phrase.repeat(4);
  return (
    <div className="relative border-y border-[#232530] bg-[#0d0e12] overflow-hidden py-4" data-testid="editorial-marquee">
      <div className="marquee-track">
        <span className="font-mono text-xs tracking-[0.35em] uppercase text-[#78716c] whitespace-nowrap pr-4">
          {strip}
        </span>
        <span className="font-mono text-xs tracking-[0.35em] uppercase text-[#78716c] whitespace-nowrap pr-4" aria-hidden="true">
          {strip}
        </span>
      </div>
    </div>
  );
};
